








































































import Vue, { PropOptions } from "vue";
import { Campaign } from "@/models";
import { audienceFileTokenRules } from "@/rules/campaign.rules";
import CampaignService from "@/services/CampaignService";
import * as Papa from "papaparse";

export default Vue.extend({
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  data() {
    return {
      rules: { ...audienceFileTokenRules.attr },
      tokenOptions:
        (this.campaign.textMessage &&
          this.campaign.textMessage.match(/{{\w*}}/g)) ||
        [],
    };
  },
  mounted() {
    if (this.$route.name !== "campaignEdit") {
      this.fillAudienceTokenMapping(this.campaign.textMessage);
    }
    this.initDropFileListeners();

    if (this.campaign.audienceFile) {
      const arr: Array<any>[] = [];
      Papa.parse(this.campaign.audienceFile.url, {
        download: true,
        skipEmptyLines: true,
        step: function (results) {
          arr.push(results.data);
        },
        complete: function (results, file) {
          window.localStorage.setItem("@csv-array", JSON.stringify(arr));
        },
      });
    }
  },
  watch: {
    "campaign.textMessage"(val) {
      this.tokenOptions = (val && val.match(/{{\w*}}/g)) || [];
      this.fillAudienceTokenMapping(val);
    },
  },
  methods: {
    fillAudienceTokenMapping(textMessage: string) {
      const newTokens =
        CampaignService.buildAudienceFileTokenMapping(textMessage);
      this.$emit("update", { audienceFileTokenMapping: newTokens });
    },
    getTokenOptions(tokenSelected: string) {
      return this.tokenOptions.filter(
        (token: string) =>
          !(this.campaign as Campaign).audienceFileTokenMapping.find(
            (t) => t.token === token
          ) || token === tokenSelected
      );
    },
    async onFileSelected(file: any) {
      const arr: Array<any>[] = [];
      Papa.parse(file, {
        skipEmptyLines: true,
        step: function (results) {
          arr.push(results.data);
        },
        complete: function (results, file) {
          window.localStorage.setItem("@csv-array", JSON.stringify(arr));
        },
      });

      this.$store
        .dispatch("uploadCampaignAudience", file)
        .then((af) => {
          this.$emit("update", {
            audienceFile: {
              name: af.name,
              "url:": af.url,
              __type: "File",
            },
            audienceBlobFile: file,
          });
          this.$store.commit("addSnackbar", {
            color: "success",
            text: `Arquivo ${file.name} anexado com sucesso!`,
          });
        })
        .catch((error) => {
          this.$store.commit("addSnackbar", {
            text: `Erro ao anexar o arquivo ${file.name}!`,
          });
        });
    },
    clean() {
      (document.getElementById("oc-file-selector") as HTMLInputElement).value =
        "";
    },
    initDropFileListeners() {
      const dropArea = document.getElementById("oc-file-drop");
      const events = ["dragenter", "dragover", "dragleave", "drop"];
      const eventsHighLight = ["dragenter", "dragover"];
      const eventsUnhighLight = ["dragleave", "drop"];
      if (dropArea) {
        events.forEach((eventName) =>
          dropArea.addEventListener(
            eventName,
            (e) => {
              e.preventDefault();
              e.stopPropagation();
            },
            false
          )
        );
        eventsHighLight.forEach((eventName) =>
          dropArea.addEventListener(
            eventName,
            (e) => {
              dropArea.classList.add("oc-highlight");
            },
            false
          )
        );
        eventsUnhighLight.forEach((eventName) => {
          dropArea.addEventListener(
            eventName,
            (e) => {
              dropArea.classList.remove("oc-highlight");
            },
            false
          );
        });
        dropArea.addEventListener(
          "drop",
          (e) => {
            const dt: any = e.dataTransfer;
            const files = dt.files;
            this.onFileSelected(files[0]);
          },
          false
        );
      }
    },
  },
});
